import React, { useEffect } from 'react';

const About: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <main>
      <section className="breadcrumb-area d-flex align-items-center" style={{backgroundImage: 'url(images/bg-img/bdrc-bg.jpg)'}}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-12 col-lg-12">
              <div className="breadcrumb-wrap text-center">
                <div className="breadcrumb-title">
                  <h2>About Us</h2>
                  <div className="breadcrumb-wrap">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/">Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">About Us</li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-area about-p pt-120 pb-120 p-relative fix">
        <div className="animations-02"><img src="img/bg/an-img-02.png" alt="contact-bg-an-02" /></div>
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="s-about-img p-relative wow fadeInLeft animated" data-animation="fadeInLeft" data-delay=".4s">
                <img src="images/about1.jpg" alt="img" />
                <div className="about-icon">
                  <img src="images/about2.jpg" alt="img" />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="about-content s-about-content wow fadeInRight animated pl-30" data-animation="fadeInRight" data-delay=".4s">
                <div className="about-title second-title pb-25">
                  <h5>About Us</h5>
                  <h2>Welcome to Bangtan Lounge - Global Eatery & Bar</h2>
                </div>
                <p style={{textAlign: 'justify'}}>
                  Located in the heart of Mira Bhayandar, Bangtan Lounge is your ultimate destination for electrifying music, unforgettable parties, and mouth-watering global cuisine. Whether you are looking to chill with friends or celebrate big, we've got the perfect vibe, beats, and bites to make every moment epic. <br />
                  If you are searching for a restro and bar near me, restaurants in Mira Road East, or a BTS cafe in Mira Road, you have found your spot.
                </p>
                <p style={{textAlign: 'justify'}}>
                  Great Food. Killer Music. Pure Vibes. <br />Come experience Mira Road's hottest lounge and dance club - only at Bangtan Lounge.
                </p>
              </div>
            </div>
          </div>
          <h3 className="mt-4">About Us</h3>
          <p style={{textAlign: 'justify'}}>
            At Bangtan Lounge, we bring together global flavors, high-energy music, and a vibrant atmosphere — right in the heart of Mira Bhayandar. Whether you are here for a casual dinner, birthday bash, or a night out with your crew, our eclectic menu, signature cocktails, and live music set the perfect mood.
            As a top-rated restaurant and bar in Mira Road, we are the go-to for foodies, party lovers, and anyone Googling "open now near me restaurants" or "eateries near me open now."
          </p>
          <p style={{textAlign: 'justify'}}>Eat Global. Party Local. Only at Bangtan Lounge - the ultimate family bar and restaurant near you.</p>
          
          <h5 style={{color: '#c07e40'}}>Ambiance - Where Vibe Meets Style</h5>
          <p style={{textAlign: 'justify'}}>
            Step into a space where luxury meets energy. With plush interiors, dynamic lighting, and a sound system that gets your heart pumping, Bangtan Lounge sets the tone for unforgettable evenings.
          </p>
          <p style={{textAlign: 'justify'}}>
            Whether you're searching for a lounge in Mira Road, a dance club in Mumbai, or a pub near me, our vibe is unmatched. It is not just a place—it's a feeling.
          </p>
          <p style={{textAlign: 'justify'}}>Your new favorite open house café and lounge in Mira Bhayandar awaits.</p>
          
          <h5 style={{color: '#c07e40'}}>Club Nights & Live Events</h5>
          <p style={{textAlign: 'justify'}}>
            We do not just play music — we create experiences. From DJ nights that light up the dancefloor to themed events, artist takeovers, and live performances, Bangtan Lounge is Mira Road's hottest dance club and event space. Regular ladies' nights, weekend clubbing, and live acts make us one of the best clubs in Mumbai for non-stop fun.
          </p>
          <p style={{textAlign: 'justify'}}>Looking for a dance club in Mumbai or a Mira Road club to unwind? We are right here.</p>
          
          <h5 style={{color: '#c07e40'}}>Global Food Experience</h5>
          <p style={{textAlign: 'justify'}}>
            Get ready to explore a world of flavors. Our carefully curated menu brings together the best of global cuisine — from sizzling Asian fare to rich Indian mains and gourmet pizzas. For those searching for "best eateries near me" or restaurants near me open now, Bangtan Lounge delivers every single time.
          </p>
          <p style={{textAlign: 'justify'}}>Ranked among the best restaurants in Mumbai, our Mira Road location is perfect for every craving.</p>
          
          <h5 style={{color: '#c07e40'}}>Signature Bar & Cocktails</h5>
          <p style={{textAlign: 'justify'}}>
            Our bar is stocked with premium spirits, brews, and cocktails crafted to perfection. Whether you are in the mood for a classic or a Bangtan special, our mixology menu hits just right.
            This is your go-to bar and restaurant near Mira Bhayandar, whether it is Friday night or a midweek unwind.
          </p>
          <p style={{textAlign: 'justify'}}>
            Searching for a nearby pub, near bar and restaurant, or best bar and restaurants near me? Bangtan Lounge has you covered.
          </p>
          
          <h5 style={{color: '#c07e40'}}>Celebrate with Us - Parties & Private Events</h5>
          <p style={{textAlign: 'justify'}}>
            Birthdays, anniversaries, or just because — Bangtan Lounge is the place to celebrate. With custom decor, curated menus, private seating, and DJ setups, we help you throw the kind of party people talk about.
            We are also popular among those looking for a nearby bar and restaurant for private events, clubs in Mumbai, or a Mira Road dance bar.
          </p>
          <p style={{textAlign: 'justify'}}>
            Book now to party in style at one of the best restaurants and clubs near you can include a small footer text block or FAQ section on the site like:
          </p>
        </div>
      </section>
    </main>
  );
};

export default About;